// reducers.js
import {types} from '../../types/types';

const initialState = {
    snackbarOpen: false,
    snackbarMessage: {},
    snackbarTemplateOpen: false,
    snackbarTemplateMessage: {},
    contactAssignedSnackbarOpen: false,
    contactAssignedSnackbarContact: {},
    reportReadyOpen: false,
    reportReadyPayload: {},
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_SNACKBAR:
            console.log("notificationReducer::SHOW_SNACKBAR", action)
            return {
                ...state,
                snackbarOpen: true,
                snackbarMessage: action.payload,
            };
        case types.HIDE_SNACKBAR:
            return {
                ...state,
                snackbarOpen: false,
                snackbarMessage: {},
            };
        case types.SHOW_TEMPLATE_SNACKBAR:
            console.log("notificationReducer::SHOW_TEMPLATE_SNACKBAR", action)
            return {
                ...state,
                snackbarTemplateOpen: true,
                snackbarTemplateMessage: action.payload,
            };
        case types.HIDE_SHOW_TEMPLATE_SNACKBAR:
            return {
                ...state,
                snackbarTemplateOpen: false,
                snackbarTemplateMessage: {},
            };
        case types.SHOW_CONTACT_ASSIGNED_SNACKBAR:
            return {
                ...state,
                contactAssignedSnackbarOpen: true,
                contactAssignedSnackbarContact: action.payload,
            };
        case types.HIDE_CONTACT_ASSIGNED_SNACKBAR:
            return {
                ...state,
                contactAssignedSnackbarOpen: false,
                contactAssignedSnackbarContact: {},
            };
        case types.SHOW_REPORT_READY_SNACKBAR:
            return {
                ...state,
                reportReadyOpen: true,
                reportReadyPayload: action.payload,
            };
        case types.HIDE_REPORT_READY_SNACKBAR:
            return {
                ...state,
                reportReadyOpen: false,
                reportReadyPayload: {},
            };
        default:
            return state;
    }
};